'use strict';

/**
 * Checks if a value is numeric.
 *
 * @param v - The value to check.
 * @returns A boolean indicating whether the value is numeric or not.
 */ function isNumeric(v) {
    return !isNaN(Number(v));
}

module.exports = isNumeric;
